export const osnTickIcon = {
  data: `<svg viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.75 7.0276L5.24667 10.7374C5.55667 11.0653 6.08333 11.0894 6.42417 10.7912C6.46 10.7591 6.49417 10.7245
 6.52417 10.6868L14.25 1"
stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>`,
  name: 'tick',
};
